import TreeSelect from './tree-select';
import mapProps from '../scripts/utils/map-props';

export default mapProps(
  [
    'value',
  ],
  {
    model: {
      prop: 'value',
      event: ['change', 'input'],
    },
  }
)(TreeSelect);
